module.exports = {
	"ja": {
		"defaultLabel": "支払い"
	},
	"en": {
		"defaultLabel": "Pay Now"
	},
	"ko": {
		"defaultLabel": "지금 지불"
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/api/components/button/i18n.json
// module id = 617
// module chunks = 1